module.exports = __webpack_public_path__ + "static/media/icon.a12a2a09.png";